var magicStyles = [".panic-bar[data-v-2cd8b666] {\n  display: contents;\n}"];

export default magicStyles;
